import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Chip,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Link, useHistory, useLocation } from "react-router-dom";
import styles from "../../../styles/global-styles";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import { GuaranteeService } from "../../../services/guarantee.service";
import { AuthService } from "../../../services/auth.service";
import { Role } from "../../../_utils/roleEnum";
import StatusGuaranteeSelect from "../../shared/selects/StatusGuaranteeSelect";
import TipificationGuaranteeSelect from "../../shared/selects/TipificationGuaranteeSelect";

const usetSyles = makeStyles((theme) => ({
  numberCircle: styles.numberCircle,
  backgroundIcon: styles.backgroundIcon,
  rightButton: styles.buttonRightHeader,
  link: styles.link,
  label: {
    marginBottom: "1.5vh",
  },
  box: {
    marginTop: "20px",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      width: "auto",
    },
  },
  detailTitle: {
    fontWeight: "800",
    color: "#1C2668",
    marginTop: theme.spacing(4),
    marginBottom: -15,
  },
  chipProduct: styles.chipProductType,
}));

const GuaranteeServiceTicket = ({ addAlert, detailAlert, guaranteeInfo }) => {
  const classes = usetSyles();
  const history = useHistory();
  const location = useLocation();

  const [guaranteeObject, setGuaranteeObject] = useState({});
  const [siteId, setSiteId] = useState({});
  const [submitForm, setSubmitForm] = useState(false);
  const [userRole, setUserRole] = React.useState(undefined);
  const [statusSelected, setStatusSelected] = React.useState(undefined);

  console.log("guaranteeInfo", guaranteeInfo);
  useEffect(() => {
    const { siteId, roleId } = AuthService.currentUserValue;
    setSiteId(siteId);
    setUserRole(roleId);

    if (!location) history.push(`/dashboard/inventario/garantias`);
    if (guaranteeInfo) {
      setGuaranteeObject(guaranteeInfo);
    }
  }, []);

  useEffect(() => {
    if (submitForm) {
      console.log("guaranteeObject", guaranteeObject);
      const serviceTicket = location.pathname.split("/")[5];
      if (serviceTicket) {
        (async () => {
          try {
            const { status } = await GuaranteeService.updateGuarantee(
              guaranteeObject,
              serviceTicket
            );
            if (status === 201) {
              setTimeout(() => {
                history.push(`/dashboard/inventario/garantias`);
              }, 2000);
              addAlert({ showAlert: true });
              detailAlert({
                severity: "success",
                message: "Service ticket actualizado exitosamente",
              });
            }
          } catch (error) {
            addAlert({ showAlert: true });
            detailAlert({
              severity: "error",
              message:
                error.msgs ||
                "Error no se pudo actualizar el service ticket de la garantía",
            });
          }
        })();
      } else {
        addAlert({ showAlert: true });
        detailAlert({
          severity: "error",
          message: "Error al recuperar el id del service ticket",
        });
      }
    }
  }, [submitForm]);

  const handleUpdateServiceTicket = async (event) => {
    event.preventDefault();
    setGuaranteeObject({ ...guaranteeObject, statusGuaranteeId: 1 });
    setSubmitForm(true);
  };

  const handleInputText = ({ target: { name, value } }) =>
    setGuaranteeObject({ ...guaranteeObject, [name]: value });

  const updateGuaranteeStatus = async (event) => {
    console.log("statusSelected", statusSelected);
    console.log(" guaranteeInfo.id", guaranteeInfo.id);

    event.preventDefault();
    const { status } = await GuaranteeService.updateStatusGuarantee(
      { statusGuaranteeId: statusSelected },
      guaranteeInfo.id
    );
    if (status === 201) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "success",
        message: "Estatus actualizado exitosamente",
      });
    }
  };

  const handleStatusSelected = (key, value) => {
    if (value) {
      setStatusSelected(value);
    }
  };

  const handleTipificationSelected = (tipification) => {
    if (tipification) {
      setGuaranteeObject({
        ...guaranteeObject,
        tipificationGuaranteeId: tipification,
      });
    }
  };

  const validateRoleGuaranteeInfo = () => {
    let disabledText = undefined;
    if (
      guaranteeInfo !== undefined &&
      (userRole === Role.Admin || userRole === Role.GuaranteeHelper)
    ) {
      disabledText = false;
    } else disabledText = true;
    return disabledText;
  };

  const updateTrackingGuarantee = async (e) => {
    e.preventDefault();
    try {
      const { status } = await GuaranteeService.updateGuarantee(
        guaranteeObject,
        guaranteeInfo.serviceTicket
      );
      if (status === 201) {
        addAlert({ showAlert: true });
        detailAlert({
          severity: "success",
          message: "Seguimiento actualizado exitosamente",
        });
      } else {
        const errorUpdateTracking = {
          errorTracking: "Error al actualizar la tipificación de la garantía",
        };
        throw errorUpdateTracking;
      }
    } catch (error) {
      console.log(error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.errorTracking ? error.errorTracking : error.msgs,
      });
    }
  };

  return (
    <>
      <div style={{ display: "inline-flex" }}>
        {!guaranteeInfo && (
          <>
            <ArrowBackIosIcon color="primary" />
            <Typography variant="body1" component={"div"}>
              <Box>
                {" "}
                <Link
                  to={`/dashboard/inventario/garantias`}
                  className={classes.link}
                >
                  Cancelar
                </Link>
              </Box>
            </Typography>
          </>
        )}
      </div>
      {guaranteeInfo === undefined && (
        <Box mt={4} style={{ fontWeight: "800", color: "#1C2668" }}>
          <Typography variant="h4">Detalles de la garantía</Typography>
          <Typography variant="body1" component={"div"}>
            Completar los campos requeridos
          </Typography>
        </Box>
      )}

      <ValidatorForm
        noValidate
        onKeyPress={(event) => {
          if (event.which === 13 /* Enter */) {
            event.preventDefault();
          }
        }}
        className={classes.form}
        method="POST"
        onSubmit={handleUpdateServiceTicket}
        onError={(errors) => console.log(errors)}
      >
        <Grid
          style={{ marginTop: 20 }}
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
        >
          {guaranteeInfo && (
            <>
              <Grid item xs={12} sm={12} md={8}>
                <Box
                  mt={8}
                  mb={-2}
                  style={{ fontWeight: "bold", color: "#1C2668" }}
                >
                  <Typography variant="h5" className={classes.detailTitle}>
                    Comentarios del cliente
                  </Typography>
                </Box>
              </Grid>
            </>
          )}

          <Grid item xs={12} sm={12} md={8}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Falla en el producto
              </Typography>
              <TextValidator
                className={classes.textField}
                fullWidth
                disabled={guaranteeInfo !== undefined}
                name="failureDetail"
                value={guaranteeObject.failureDetail || ""}
                validators={["required"]}
                onChange={(e) => handleInputText(e)}
                errorMessages={["Escribir en detalle la falla del producto"]}
                variant="outlined"
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Notas adicionales de la falla
              </Typography>
              <TextValidator
                className={classes.textField}
                fullWidth
                disabled={guaranteeInfo !== undefined}
                multiline
                rowsMax={4}
                name="extraNotes"
                value={guaranteeObject.extraNotes || ""}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
              />
            </Box>
          </Grid>

          {guaranteeInfo && (
            <>
              <Grid item xs={12} sm={12} md={8}>
                <Box
                  mt={8}
                  mb={-2}
                  style={{ fontWeight: "bold", color: "#1C2668" }}
                >
                  <Typography variant="h5" className={classes.detailTitle}>
                    Seguimiento
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={8}>
                <Box className={classes.box}>
                  {userRole === Role.Seller && (
                    <>
                      <Typography
                        variant="body2"
                        component={"div"}
                        className={classes.label}
                      >
                        Estatus
                      </Typography>
                      <Chip
                        label={
                          guaranteeInfo.status_guarantee.name || "Sin asignar"
                        }
                        className={classes.chipProduct}
                      />
                    </>
                  )}
                  {(userRole === Role.GuaranteeHelper ||
                    userRole === Role.Admin) && (
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      alignItems="center"
                    >
                      <Grid item>
                        <StatusGuaranteeSelect
                          value={guaranteeInfo.statusGuaranteeId}
                          status={handleStatusSelected}
                        />
                      </Grid>

                      {statusSelected !== undefined && (
                        <Grid item>
                          <Button
                            className={classes.rightButton}
                            variant="contained"
                            color="primary"
                            type="submit"
                            onClick={(e) => updateGuaranteeStatus(e)}
                            style={{ marginRight: 50, width: 200 }}
                          >
                            Actualizar estatus
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={8}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Comentarios
                  </Typography>
                  <TextValidator
                    className={classes.textField}
                    fullWidth
                    multiline
                    rowsMax={4}
                    disabled={validateRoleGuaranteeInfo()}
                    name="trackingComments"
                    value={guaranteeObject.trackingComments || ""}
                    validators={["required"]}
                    onChange={(e) => handleInputText(e)}
                    errorMessages={[
                      "Escribir en detalle la falla del producto",
                    ]}
                    variant="outlined"
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={8}>
                <Box className={classes.box}>
                  {userRole === Role.Seller && (
                    <>
                      <Typography
                        variant="body2"
                        component={"div"}
                        className={classes.label}
                      >
                        Tipificación
                      </Typography>
                      <Chip
                        label={
                          guaranteeInfo.tipification_guarantee?.name ||
                          "Sin asignar"
                        }
                        style={{ width: 250 }}
                        className={classes.chipProduct}
                      />
                    </>
                  )}
                  {(userRole === Role.GuaranteeHelper ||
                    userRole === Role.Admin) && (
                    <TipificationGuaranteeSelect
                      value={guaranteeInfo.tipificationGuaranteeId}
                      tipification={handleTipificationSelected}
                    />
                  )}
                </Box>
              </Grid>
            </>
          )}

          {(userRole === Role.GuaranteeHelper || userRole === Role.Admin) &&
            guaranteeInfo && (
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="flex-end"
              >
                <Grid item>
                  <Button
                    className={classes.rightButton}
                    variant="contained"
                    color="primary"
                    onClick={(e) => updateTrackingGuarantee(e)}
                    style={{ margin: 50, width: 200 }}
                  >
                    Actualizar Seguimiento
                  </Button>
                </Grid>
              </Grid>
            )}

          {!guaranteeInfo && (
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="flex-end"
            >
              <Grid item>
                <Button
                  className={classes.rightButton}
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ margin: 50, width: 200 }}
                >
                  Añadir
                </Button>
              </Grid>
            </Grid>
          )}
        </Grid>
      </ValidatorForm>
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(GuaranteeServiceTicket);
